export enum Roles {
  METHODIST = "methodist",
  TEACHER = "user",
  AUTH = "auth"
}